export interface ChargingReportConfiguration {
  id: number;
  externalChargingStationId: string;
  chargingStationName?: string;
  scheduledDay: number;
  feeCalculationType: ChargingFeeCalculationType;
  monthlyFixedFeeEuros: string;
  chargingServiceFeeMarginalEurosKwh: string;
  chargingServiceFeePercentage: string;
  includeInvoiceInfo: boolean;
  includeSessionAmount: boolean;
  includeProductDescription: boolean;
  includeTimeTariffs: boolean;
  includeCustomerName: boolean;
  recipientEmails: string[];
  dateCreated: string
}

export interface ChargingReportConfigurationForm {
  externalChargingStationId?: string;
  chargingStationName?: string;
  scheduledDay?: number;
  feeCalculationType?: ChargingFeeCalculationType;
  monthlyFixedFeeEuros?: string;
  chargingServiceFeeMarginalEurosKwh?: string;
  chargingServiceFeePercentage?: string;
  includeInvoiceInfo: boolean;
  includeSessionAmount: boolean;
  includeProductDescription: boolean;
  includeTimeTariffs: boolean;
  includeCustomerName: boolean;
  recipientEmails?: string[];
}

export enum ChargingFeeCalculationType {
  NONE = "NONE",
  MONTHLY_FIXED_FEE = "MONTHLY_FIXED_FEE",
  MARGIN = "MARGIN",
  PERCENTAGE_OF_TURNOVER = "PERCENTAGE_OF_TURNOVER"
}

export const CHARGING_FEE_CALCULATION_TYPE_MAP: {[key in ChargingFeeCalculationType]: string} = {
  NONE: 'Tasu ei arvestata',
  MONTHLY_FIXED_FEE: 'Igakuine tasu raporti väljastamise eest',
  MARGIN: 'Laadimisteenuse tasu marginaal',
  PERCENTAGE_OF_TURNOVER: 'Laadimise teenustasu laadimiskäibelt'
};

export const CHARGING_FEE_CALCULATION_TYPE_OPTIONS = [   
    {
        label: CHARGING_FEE_CALCULATION_TYPE_MAP[ChargingFeeCalculationType.NONE],
        value: ChargingFeeCalculationType.NONE,
    },
    {
      label: CHARGING_FEE_CALCULATION_TYPE_MAP[ChargingFeeCalculationType.MONTHLY_FIXED_FEE],
        value: ChargingFeeCalculationType.MONTHLY_FIXED_FEE,
    }, 
    {
      label: CHARGING_FEE_CALCULATION_TYPE_MAP[ChargingFeeCalculationType.MARGIN],
        value: ChargingFeeCalculationType.MARGIN,
    },
    {
      label: CHARGING_FEE_CALCULATION_TYPE_MAP[ChargingFeeCalculationType.PERCENTAGE_OF_TURNOVER],
        value: ChargingFeeCalculationType.PERCENTAGE_OF_TURNOVER
    }
];

export enum ChargingReportConfigurationSortFields {
  ID = "ID"
}

export interface ChargingReportConfigurationFilters {
  search?: string;
}